import React from 'react';
import BuyTwoLineButton from './buttons/BuyTwoLineButton';
import BuyNowButton from './buttons/BuyNowButton';
import FreeWatchButton from './buttons/FreeWatchButton';
import { faPlay, faCalendarAlt, faTicketAlt } from '@fortawesome/free-solid-svg-icons'
import { dateToYearMonthDateString, getMmmDate, stringFormat, getMmmHhMmDate, timeout } from './utils/ApiUtils';
import { isEqual } from 'lodash';
import { COLORS } from './utils/Constants';
import TileWeb from './common/TileWeb';
import TileMobile from './common/TileMobile';
import firebase from './utils/firebase';

const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
let userId = 0, isMobile = false, isVerifiedOld = false, expiryObject = [];
let firebaseTimeObj = { key: 1 };
// let tempImage = "https://c4.wallpaperflare.com/wallpaper/533/628/947/4k-beautiful-background-image-wallpaper-preview.jpg";

export default class TileMovie extends React.Component {
    constructor(props) {
        super(props);
        this.state = { mouseOver: false, linkText: '', duration: '', displayMovieObj: '', firebaseIndex: 0 };
        isMobile = window.innerWidth<768;
    }
    componentDidMount() {
        let movieObj = this.props.movieObj;
        if(movieObj&&movieObj.movie) {
            let displayMovieObj = this.customDisplayObject(movieObj);
            this.setState({ movieObj: movieObj, displayMovieObj: displayMovieObj });
            this.listenForExpiryTime(movieObj);
        }
    }
    componentDidUpdate() {
        let movieObj = this.props.movieObj;
        let oldMovieObj = this.state.movieObj;
        try {
            // console.log('check here oldMovieObj='+(oldMovieObj)+' new movieObj='+(movieObj));
            let { expiryTime, buyStatus } = this.props;
            let newExpiry = expiryTime;
            let oldExpiry = this.state.expiryTime;
            let movieObjChanged = !isEqual(oldMovieObj, movieObj);
            if(this.props.isVerified!=isVerifiedOld) {
                movieObjChanged = true;
                isVerifiedOld = this.props.isVerified;
            }
            if(userId==0&&this.props.userId) {
                userId = this.props.userId;
            }
            if(movieObjChanged) {
                let displayMovieObj = this.customDisplayObject(movieObj);
                this.setState({ movieObj: movieObj, displayMovieObj: displayMovieObj, expiryTime: expiryTime, 
                    buyStatus: buyStatus });
                this.listenForExpiryTime(movieObj);
            } else if(!isEqual(newExpiry, oldExpiry)) {
                this.setState({ expiryTime: expiryTime, buyStatus: buyStatus });
                this.listenForExpiryTime(movieObj);
            }
        } catch(e) {
            console.log('Error in setting movie state.');
        }
    }
    listenForExpiryTime = async(movieObj) => {
        await timeout(500);
        while(userId<1) {
            console.log('waiting for userId='+userId);
            await timeout(500);
        }
        let locatorName = movieObj.azureStreamingLocatorName;
        let isFound = expiryObject.find(element => element==locatorName);
        console.log('item find status='+isFound+' locator='+locatorName);
        if(isFound) {
            console.log('item already there.');
        } else {
            let { expiryTime, buyStatus, userCurrentCountry } = this.props;
            let movieReleaseDate = movieObj.movieReleaseDate;
            let currentTime = new Date().getTime()/1000;
            console.log(' currentTime='+currentTime+' movieReleaseDate='+movieReleaseDate+' buyStatus='+buyStatus);
            if(buyStatus&&currentTime<expiryTime&&currentTime>movieReleaseDate) {
                expiryObject.push(locatorName);
                this.setFirebaseListener(movieObj.id, locatorName, userCurrentCountry);
            }
            console.log('locatorName='+locatorName+' expiryObj='+expiryObject);
        }
    }
    setFirebaseListener = (movieId, currentLocator, currentCountry) => {
        console.log('movie listener userId='+userId+' currentLocator='+currentLocator+' currentCountry='+currentCountry);
        firebase.database().ref("users").child(userId).child(currentLocator).child(currentCountry).child("expiryTime").on("value", snapshot => {
            let snapValue = snapshot.val();
            let snapKey = snapshot.key;
            console.log('snapKey='+snapKey+' snapValue='+snapValue);
            if(snapKey&&snapKey=="expiryTime"&&snapValue) {
                console.log('Button change kardo.');
                firebaseTimeObj[movieId] = snapValue;
                console.log('firebaseTimeObj='+JSON.stringify(firebaseTimeObj));
                this.setState({ firebaseIndex: this.state.firebaseIndex+1 });
            }
        });
    }
    customDisplayObject = (movieObj) => {
        let tempMovie = movieObj.movie;
        let { movieName, rating, directors, writers, stars, producers, duration, mediaLinks, 
            summary, language, genre, productionHouse } = tempMovie; 
        movieName = stringFormat(movieName, entities);
        directors = stringFormat(directors, entities);
        writers = stringFormat(writers, entities);
        stars = stringFormat(stars, entities);
        producers = stringFormat(producers, entities);
        productionHouse = stringFormat(productionHouse, entities);
        genre = stringFormat(genre, entities);
        language = stringFormat(language, entities);
        summary = stringFormat(summary, entities);

        let sharedUrl = movieObj.shareUrl;
        let verifyIdentity = movieObj.verifyIdentity&&(!this.props.isVerified);
        let viewTime = movieObj.movieViewTime; 
        let ticket = 0;
        let currency = 'USD';
        let movieCountry = 'United States';
        if(movieObj.moviePriceList&&movieObj.moviePriceList[0]) {
            ticket = movieObj.moviePriceList[0].price;
            currency = movieObj.moviePriceList[0].currency;
            movieCountry = movieObj.moviePriceList[0].countryname;
            if((movieCountry!==this.props.userCurrentCountry)&&(movieObj.moviePriceList[1])) {
                ticket = movieObj.moviePriceList[1].price;
                currency = movieObj.moviePriceList[1].currency;
                movieCountry = 'United States';
            }
        }
        let uploadId = movieObj.id;
        let enableBuyWatchnow = movieObj.enableBuyWatchnow ;
        let enableBuyPrebooking = movieObj.enableBuyPrebooking;
        let movieReleaseDate = movieObj.movieReleaseDate;
        console.log('sharedUrl='+sharedUrl+' ticket='+ticket);
        let url = mediaLinks&&mediaLinks.banner ? mediaLinks.banner : require('./images/31new.jpg');
        if(mediaLinks&&mediaLinks.banner_thumbnail) {
            url = mediaLinks.banner_thumbnail;
        }
        let portriaturl = mediaLinks&&mediaLinks.portriat ? mediaLinks.portriat : require('./images/31new.jpg');
        if(mediaLinks&&mediaLinks.portrait_thumbnail) {
            portriaturl = mediaLinks.portrait_thumbnail;
        }
        let displayMovieObj = { movieName: movieName, directors: directors, writers: writers, stars: stars, 
            producers: producers, sharedUrl: sharedUrl, viewTime: viewTime*24, ticket: ticket, 
            currency: currency, uploadId: uploadId, enableBuyWatchnow: enableBuyWatchnow, movieCountry: movieCountry,
            enableBuyPrebooking: enableBuyPrebooking, movieReleaseDate: movieReleaseDate, verifyIdentity: verifyIdentity,
            bannerImage: url, portriatImage: portriaturl, rating: rating, duration: duration, productionHouse: productionHouse,
            summary: summary, genre: genre, language: language };
        return displayMovieObj;
    }
    shareUrl = (sharedUrl, index) => {
        try {
            if (navigator.share) {
                navigator
                  .share({
                    text: 'Check out HIT Movie:',
                    url: sharedUrl,
                  })
                  .then(() => {
                    console.log('Successfully shared');
                  })
                  .catch(error => {
                    console.error('Something went wrong sharing the blog', error);
                  });
            } else {
                this.setState({ linkText: 'Link Copied!' });
                setTimeout(
                    () => this.setState({ linkText: '' }), 
                    1000
                );
                navigator.clipboard.writeText(sharedUrl);
            }
        } catch(e) {
            var copyText = document.getElementById(index);
            if(copyText&&copyText.select) {
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                document.execCommand("copy");
            }
        } 
    }
    buyButton = (index, movieObj, showPrice) => {
        console.log('big button index='+index+' movie='+JSON.stringify(movieObj));
        switch(index) {
            case 0:
                // Coming soon
                console.log('Coming soon Disabled button');
                break;
            case 1:
                // preBooking Movie
                this.props.payMovie(movieObj, showPrice);
                break;
            case 2:
                // Buy now
                this.props.payMovie(movieObj, showPrice);
                break;
            case 3:
                // Watch now
                this.props.payMovie(movieObj, showPrice);
                // this.props.openPlayer(movieObj.id, movieObj, false);
                break;
            case 4:
                // Watch On future date
                this.props.payMovie(movieObj, showPrice);
                break;
            case 5:
                // Free to watch
                alert('Watch the movie now on Apple TV.');
                // this.props.openPlayer(movieObj.id, movieObj, false);
                break;
            case 6:
                // Id required and not verified
                this.props.openIdentityPopup();
                break;
            default:
                this.props.payMovie(movieObj, showPrice);
                break;
        };
    }
    openPlayer = (uploadId, index, movieObj) => {
        if(index===3||index===5) {
            this.props.openPlayer(uploadId, movieObj, false);
        } else {
            this.props.openPlayer(uploadId, movieObj, true);
        }
    }
    render() {
        let font11 = 32, font12 = 20, fontIcon = 24;
        if(isMobile) {
            font11 = 22; font12 = 16;
        }
        let index = 0;
        let { linkText, displayMovieObj, expiryTime, buyStatus, movieObj } = this.state;
        let viewTime = displayMovieObj.viewTime;
        let releaseString = '', expiryString = '', releaseDateTimeString = '';
        let movieReleaseDate = displayMovieObj.movieReleaseDate;
        let verifyIdentity = displayMovieObj.verifyIdentity;
        let currentTime = new Date().getTime()/1000;
        let watchNowString = 'Watch Now';
        if(movieReleaseDate) {
            releaseString = dateToYearMonthDateString(movieReleaseDate);
            releaseDateTimeString = getMmmHhMmDate(movieReleaseDate);
        }
        if(movieObj&&movieObj.movieExpiryDate) {
            expiryString = 'Watch By: '+getMmmDate(movieObj.movieExpiryDate);
        }
        let preBookText = '', showTimeString = 'Hours';
        if(verifyIdentity) {
            // Id required and not verified
            index = 6;
        } else if(expiryTime&&(currentTime>expiryTime)) {
            index = 2;
        } else if(buyStatus) {
            if(currentTime<movieReleaseDate) {
                preBookText = 'Watch On';
                index = 4;
            } else {
                index = 3;
                let movieId = movieObj.id;
                let firebaseTime = false;
                if((movieId in firebaseTimeObj)) {
                    firebaseTime = firebaseTimeObj[movieId];
                } 
                console.log('firebaseTime='+firebaseTime+' movieId='+movieId);
                if(firebaseTime) {
                    if(firebaseTime-currentTime>0) {
                        viewTime = parseInt((firebaseTime-currentTime)/3600);
                        if(viewTime>0) {
                            viewTime++;
                        } else {
                            viewTime = parseInt((firebaseTime-currentTime)/60);
                            viewTime++;
                            showTimeString = 'Minutes';
                        }    
                    } else {
                        index = 2;
                    }
                }
                else if(expiryTime) {
                    viewTime = parseInt((expiryTime-currentTime)/3600);
                    if(viewTime>0) {
                        viewTime++;
                    } else {
                        viewTime = parseInt((expiryTime-currentTime)/60);
                        viewTime++;
                        showTimeString = 'Minutes';
                    }
                }
            }
        } else if(displayMovieObj.enableBuyWatchnow) {
            index = 2;  // Buy Now
        } else if(displayMovieObj.enableBuyPrebooking) {
            index = 1;  // Accept Pre-booking
            preBookText = 'Pre-Book';
        } else if(movieReleaseDate) {
            index = 0;  // Coming Soon
        } 
        if(movieObj&&movieObj.demoMode) {
            index = 5;
            watchNowString = 'Free to Watch';
        }
        let uploadId = displayMovieObj.uploadId;
        let currency = displayMovieObj.currency;
        let ticket = displayMovieObj.ticket;
        let movieCountry = displayMovieObj.movieCountry;
        // console.log('movieReleaseDate='+movieReleaseDate+' currentTime='+currentTime+' expireyTime='+expiryTime
        // +' ticket='+ticket+' currency='+currency+' viewtime='+viewTime+' buyStatus='+buyStatus+' releaseString='+releaseString);
        let button = <div />;
        switch(index) {
            case 0:
                button = <BuyNowButton fontsize1={font11} fontsize2={font12} bgColor={COLORS.greyButton} index={0} icon={faCalendarAlt}
                fontColor={COLORS.greyButton} fontIcon={fontIcon} strValue1={'Coming Soon'} strValue2={'Valid'} strValue3={showTimeString}
                strValue4={currency} strValue5={ticket} strValue6={viewTime} />
                break;
            case 1:
                button = <BuyNowButton fontsize1={font11} fontsize2={font12} bgColor={COLORS.yellow} index={0} icon={faTicketAlt}
                fontColor={COLORS.yellowLight} fontIcon={fontIcon} strValue1={preBookText} strValue2={'Valid'} strValue3={showTimeString}
                strValue4={currency} strValue5={ticket} strValue6={viewTime} />
                break;
            case 2:
                button = <BuyTwoLineButton fontsize1={font11} fontsize2={font12} bgColor={COLORS.yellowLight} index={0} icon={faPlay}
                fontColor={COLORS.darkGreen} fontIcon={fontIcon} strValue1={currency} strValue2={ticket} strValue3={'Buy Now'}
                strValue4={''} strValue5={viewTime} />
                break;
            case 3:
                button = <BuyNowButton fontsize1={font11} fontsize2={font12} bgColor={COLORS.darkGreen} index={0} icon={faPlay}
                fontColor={COLORS.darkGreen} fontIcon={fontIcon} strValue1={'Buy Again'} strValue2={'Valid'} strValue3={showTimeString}
                strValue4={currency} strValue5={ticket} strValue6={viewTime} />
                break;
            case 4:
                button = <BuyTwoLineButton fontsize1={font11} fontsize2={font12} bgColor={COLORS.yellowLight} index={0} icon={faTicketAlt}
                fontColor={COLORS.yellowLight} fontIcon={fontIcon} strValue1={currency} strValue2={ticket} strValue3={preBookText}
                strValue4={releaseString} strValue5={viewTime} />
                break;
            case 5:
                button = <FreeWatchButton fontIcon={fontIcon} strValue1={watchNowString} bgColor={COLORS.darkGreen} index={0} 
                icon={faPlay} />
                break;
            case 6:
                button = <BuyTwoLineButton fontsize1={font11} fontsize2={font12} bgColor={COLORS.greyButton} index={0} icon={faPlay}
                fontColor={COLORS.darkGreen} fontIcon={fontIcon} strValue1={currency} strValue2={ticket} strValue3={'Verify Id'}
                strValue4={'To Buy'} strValue5={viewTime} />
                break;
            default:
                button = <div />
                break;
        };
        let rating = displayMovieObj.rating;
        let ratingImage = '';
        let trailerText = 'Buy Movie';
        if(index===3||index===5) {
            trailerText = 'Buy Again';
        }
        if(movieObj&&movieObj.demoMode) {
            trailerText = 'Watch on Apple TV';
        }
        switch(rating) {
            case '0+':
                ratingImage = require('./images/0.png');
                break;
            case '7+':
                ratingImage = require('./images/7.png');
                break;
            case '13+':
                ratingImage = require('./images/13.png');
                break;
            default:
                ratingImage = require('./images/18.png');
                break;
        }
        let showPrice = { currency: currency, price: ticket, movieCountry: movieCountry };
        // console.log('Tile Movie Web loaded isMobile='+isMobile);
        if(isMobile) {
            return (
                <TileMobile index={index} uploadId={uploadId} movieObj={movieObj} linkText={linkText} 
                trailerText={trailerText} ratingImage={ratingImage} showPrice={showPrice} expiryString={expiryString}
                releaseDateTimeString={releaseDateTimeString} button={button} displayMovieObj={displayMovieObj}
                openPlayer={this.openPlayer} shareUrl={this.shareUrl} buyButton={this.buyButton} />
            );
        }
        return (
            <TileWeb index={index} uploadId={uploadId} movieObj={movieObj} linkText={linkText} 
            trailerText={trailerText} ratingImage={ratingImage} showPrice={showPrice} expiryString={expiryString}
            releaseDateTimeString={releaseDateTimeString} button={button} displayMovieObj={displayMovieObj}
            openPlayer={this.openPlayer} shareUrl={this.shareUrl} buyButton={this.buyButton} />
        );
  }
}
 
